import axios from 'axios';
import api from '../api/axios';
import posthog from 'posthog-js';

const loadRazorpay = async (amount, planName, currency) => {
  let rzp = null;

  try {
    // 1️⃣ Create Razorpay order via backend
    const res = await axios.post(
      `${api}/user/create-order`,
      { amount, currency },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    const { order } = res.data;

    if (!order || !order.amount) {
      throw new Error('Invalid Razorpay order data');
    }

    // 2️⃣ Razorpay checkout options
    const options = {
      key: process.env.RAZORPAY_KEY_ID, // ✅ Use Razorpay Test Key or ENV variable
      amount: order.amount,
      currency: currency,
      name: 'KaliyugAi',
      description: `Purchase of ${planName}`,
      order_id: order.id,
      handler: async function (response) {
        // 3️⃣ On success, verify payment with backend
        try {
          const verifyRes = await axios.post(
            `${api}/user/verify-payment`,
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              amount: order.amount / 100, // convert to rupees
              currency: currency,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );

          if (verifyRes.data.success) {
            posthog.capture('payment_completed', {
              plan_name: planName,
              amount,
              currency,
              order_id: response.razorpay_order_id,
            });
            alert('✅ Payment verified and tokens added!');
          } else {
            posthog.capture('payment_failed', {
              plan_name: planName,
              amount,
              currency,
              order_id: response.razorpay_order_id,
            });
            alert('⚠️ Payment verification failed!');
          }
        } catch (error) {
          console.error('Verification failed:', error);
          posthog.captureException(error, {
              endpoint: '/user/verify-payment',
              plan_name: planName,
              amount,
              currency,
              order_id: response.razorpay_order_id,
              error: error,
            });
          alert('❌ Payment verification error. Please contact support.');
        } finally {
          document.body.style.overflow = 'auto';
        }
      },
      modal: {
        ondismiss: function () {
          document.body.style.overflow = 'auto';
        },
      },
      prefill: {
        name: 'User Name',
        email: 'user@example.com',
      },
      theme: {
        color: '#000',
      },
    };

    // 4️⃣ Open Razorpay modal
    document.body.style.overflow = 'hidden';

    rzp = new window.Razorpay(options);
    rzp.open();
  } catch (err) {
    console.error('Razorpay error:', err);
    posthog.captureException(err, {
      endpoint: '/user/create-order',
      plan_name: planName,
      amount,
      currency,
    });
    alert('Unable to complete payment. Please try again later.');
    document.body.style.overflow = 'auto';
  } finally {
    // fallback safety net
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 3000);
  }
};

export default loadRazorpay;
